import React from "react";
import { Form, Image } from "react-bootstrap";
import classnames from "classnames";
import { TopTextReusableComponent } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { InputBoxComponent } from "../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { ReusableOnboardingButton } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import RightSidePannel from "../../rightSidePannelReusable/RightSidePannel";
import InputNumberFunc from "../../../../../../function/InputNumberFunc";
import { DecimalValue } from "../../../../../../function/InputCharNumCheckFunc";
import { ReservationTimeModel } from "../../../../../vendorOnboradingComponents/reusableOnboardingPopupComponent/ReservationTimeModel";

export const WalkinWaitlist = ({
  state,
  onWalkinWaitlistChangeHandler,
  onChange,
  onFocusOut,
  walkinWaitlistTableKeptOpen,
  walkinWaitlistTableKeptClosed,
  walkinWaitlistTableKeptButtonClick,
  onClickWalkinSubmit,
  errors,
}) => {
  return (
    <React.Fragment>
      <div className="col-12 onboarding-back-button-all-screen">
        <div
          className="back_button-link"
          onClick={onWalkinWaitlistChangeHandler}
        >
          <Image
            src={require("../../../../../../assets/images/Icon/onBoardBack.png")}
            alt="Back Button"
            title="Back Button"
          />
        </div>
      </div>
      <div className="display-toggle-stepup-button">
        <RightSidePannel selectedTab={4} />
      </div>
      <div className="walkin-waitlist-main-box">
        <TopTextReusableComponent headingText="Seating Setting for Walk-In Waitlist" />
        <div className="col-5 col-sm-5 col-md-4 col-lg-4 col-xl-4 p-0">
          <InputBoxComponent
            displayLabel={true}
            controlId="distance"
            labelText="Distance"
            placeHolder="eg. 0.5km*"
            showLabelSmall={true}
            showLabelSmallText="(distance in km)"
            min="0"
            max="1000"
            maxLength="4"
            name="distance"
            inputType="number"
            onChange={onChange}
            onFocusOut={onFocusOut}
            value={state.distance}
            onKeyDown={DecimalValue}
            required="required"
            error={errors.distance}
            inputClassName={classnames(
              "input-component-inputfield text-center pr-4",
              {
                invalid: errors.distance,
              }
            )}
          />
        </div>
        <div className="col-5 col-sm-5 col-md-4 col-lg-4 col-xl-4 p-0 subscription_main_error_margin">
          <InputBoxComponent
            displayLabel={true}
            controlId="requestPeriod"
            labelText="Request Period"
            placeHolder="eg. 50*"
            name="requestPeriod"
            min="0"
            max="99"
            maxLength="2"
            inputType="number"
            onChange={onChange}
            onFocusOut={onFocusOut}
            value={state.requestPeriod}
            onKeyDown={InputNumberFunc}
            required="required"
            showLabelSmall={true}
            showLabelSmallText="(minimum period before arrival)"
            // error={errors.requestPeriod}
            inputClassName={classnames(
              "input-component-inputfield text-center pr-4",
              {
                invalid: errors.requestPeriod,
              }
            )}
          />
          <p className="small-bottom-text-input-seatingarea">min</p>
          <Form.Text className="w-100 text-muted text-center input-component-bottom position-absolute">
            <div className="text-danger text-capitalize">
              {errors.requestPeriod === "requestPeriod is required"
                ? "request period is required"
                : null}
            </div>
          </Form.Text>
        </div>
        <div className="walkin-waitlist-section-two">
          <h4>Do you provide services for the following?</h4>
          <div className="col-12">
            <div className="row align-items-center">
              <div className="col-5 col-sm-5 col-md-6 col-lg-5 col-xl-5 pl-0">
                <div className="top-seating-area-heading">
                  <h4 className="big-heading-text m-0">Minimum Person</h4>
                </div>
              </div>
              <div className="col-4 col-sm-4 col-md-6 col-lg-4 col-xl-4 pr-0">
                <div>
                  <div className="position-relative">
                    <InputBoxComponent
                      displayLabel={false}
                      controlId="minimumPerson"
                      placeHolder="eg. 1*"
                      min="1"
                      max="99"
                      name="minimumPerson"
                      inputType="number"
                      onChange={onChange}
                      onFocusOut={onFocusOut}
                      value={state.minimumPerson}
                      onKeyDown={InputNumberFunc}
                      required="required"
                      // error={errors.minimumPerson}
                      inputClassName={classnames(
                        "input-component-inputfield text-center pr-4",
                        {
                          invalid: errors.minimumPerson,
                        }
                      )}
                    />
                    <p className="small-bottom-text-input-seatingarea">pax</p>
                    <Form.Text className="w-100 text-muted text-center input-component-bottom position-absolute">
                      <div className="text-danger text-capitalize">
                        {errors.minimumPerson === "minimumPerson is required"
                          ? "minimum person is required"
                          : null}
                      </div>
                    </Form.Text>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 subscription_main_error_margin-two">
            <div className="row align-items-center margin-bottom-chains-onboarding mt-4">
              <div className="col-5 col-sm-5 col-md-6 col-lg-5 col-xl-5 pl-0">
                <div className="top-seating-area-heading">
                  <h4 className="big-heading-text m-0">Table is kept for</h4>
                  <p className="small-heading-text">
                    (Table is kept for stipulated time and cancelled)
                  </p>
                </div>
              </div>
              <div className="col-4 col-sm-4 col-md-6 col-lg-4 col-xl-4 pr-0">
                <div>
                  <div className="position-relative">
                    <div onClick={walkinWaitlistTableKeptOpen}>
                      <InputBoxComponent
                        displayLabel={false}
                        controlId="walkinWaitlistTableKeptFor"
                        placeHolder="Select*"
                        min="1"
                        max="99"
                        name="walkinWaitlistTableKeptFor"
                        inputType="number"
                        onChange={onChange}
                        value={state.walkinWaitlistTableKeptFor}
                        required="required"
                        disabled={true}
                        error={errors.walkinWaitlistTableKeptFor}
                        inputClassName={classnames(
                          "input-component-inputfield text-center pr-4",
                          {
                            invalid: errors.walkinWaitlistTableKeptFor,
                          }
                        )}
                      />
                    </div>
                    <p className="small-bottom-text-input-seatingarea">min</p>
                    <Form.Text className="w-100 text-muted text-center input-component-bottom position-absolute">
                      <div className="text-danger text-capitalize">
                        {state.walkinWaitlistTableKeptFor === "" &&
                        state.walkinWaitlistError === true
                          ? "Table is kept for required"
                          : null}
                      </div>
                    </Form.Text>
                    <ReservationTimeModel
                      onOpenModal={walkinWaitlistTableKeptOpen}
                      open={state.walkinWaitlistTableKeptForPopup}
                      onCloseModal={walkinWaitlistTableKeptClosed}
                      buttonTitle="Table is kept for"
                      buttonText="Table is kept for"
                      headerText="Table is kept for"
                      displayButtonThree={true}
                      timeTextOne="00 &nbsp;&nbsp; Minutes"
                      timeTextTwo="05 &nbsp;&nbsp; Minutes"
                      timeTextThree="10 &nbsp;&nbsp; Minutes"
                      timeTextFour="15 &nbsp;&nbsp; Minutes"
                      timeTextFive="20 &nbsp;&nbsp; Minutes"
                      timeTextSix="30 &nbsp;&nbsp; Minutes"
                      timeOneClick={(e) =>
                        walkinWaitlistTableKeptButtonClick(e, "00")
                      }
                      timeTwoClick={(e) =>
                        walkinWaitlistTableKeptButtonClick(e, "05")
                      }
                      timeThreeClick={(e) =>
                        walkinWaitlistTableKeptButtonClick(e, "10")
                      }
                      timeFourClick={(e) =>
                        walkinWaitlistTableKeptButtonClick(e, "15")
                      }
                      timeFiveClick={(e) =>
                        walkinWaitlistTableKeptButtonClick(e, "20")
                      }
                      timeSixClick={(e) =>
                        walkinWaitlistTableKeptButtonClick(e, "30")
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="onboarding-map-setup-screen-autodetect-button">
          <ReusableOnboardingButton
            buttonTitle="Back Button"
            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
            buttonText="Back"
            onClick={onWalkinWaitlistChangeHandler}
          />
          <ReusableOnboardingButton
            buttonTitle="Next Button"
            buttonClass={
              state.distance === "" ||
              state.requestPeriod === "" ||
              state.minimumPerson === "" ||
              state.walkinWaitlistTableKeptFor === ""
                ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
            }
            disabled={
              state.distance === "" ||
              state.requestPeriod === "" ||
              state.minimumPerson === "" ||
              state.walkinWaitlistTableKeptFor === ""
                ? true
                : false
            }
            buttonText="Next"
            buttonType="button"
            onClick={onClickWalkinSubmit}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default WalkinWaitlist;
